.mvSummary {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: white;
    width: 100%;
    height: 100%;
    overflow: auto;

    @media screen and (min-width: 768px) {
        width: 50%;
    }
}

.mvSummaryBody {
    flex-grow: 1;
    padding: 0 1.5rem 1rem 1.5rem;
}

.mvSummaryHeader {
    padding: 0 1.5rem;
}

.mvSummaryFooter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    padding: 1rem;
    border-top: 1px solid #dfdfdf;
}

.mvSummaryTitle {
    margin-top: 1rem;
}

.mvSummaryArea {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 1rem 0;
    border-bottom: 1px solid #dfdfdf;

    h3 {
        margin-bottom: 0.5rem;
        margin-top: 0;
        font-size: 1rem;
        & + span {
            color: rgba(0, 0, 0, 0.5);
        }
    }

    > span {
        margin-right: 1rem;
    }
}

.mvSummaryAreaMain {
    flex-grow: 1;
}

.mvSummaryTotal {
    display: flex;
    align-items: center;
    padding: 1rem 0;
    span {
        font-weight: 600;
        color: #14456b;
    }
}

.mvSummaryAreaRemoveButton {
    appearance: none;
    outline: 0;
    background-color: transparent;
    cursor: pointer;
    padding: 0.5rem;
    border: 0;
    margin: 0;

    &:disabled {
        opacity: 0.4;
        pointer-events: none;
    }
}

.mvSummaryRemoveAreaIcon {
    width: 10px;
}

.mvSummaryBackIcon {
    margin-right: 0.5rem;
    width: 12px;
}
